import React, { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 px-8 py-5 flex justify-between items-center transition-all duration-300 ${
      scrolled ? 'bg-brand-black/95 backdrop-blur-sm border-b border-brand-gold/10' : 'bg-gradient-to-b from-brand-black/95 to-transparent'
    }`}>
      <a href="#" className="font-serif text-lg font-medium text-brand-text tracking-[0.04em] no-underline">
        Harald <span className="text-brand-gold">Suekar</span>
      </a>
      <a href="#kontakt" className="text-[0.75rem] font-medium tracking-[0.1em] uppercase text-brand-gold no-underline border border-brand-gold3 px-5 py-2 rounded-sm transition-all duration-200 hover:bg-brand-gold hover:text-brand-black">
        Gespräch anfragen
      </a>
    </nav>
  );
}